// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"g","attrs":{},"children":[{"tag":"path","attrs":{"stroke":"#000","d":"M12 18H12.0039V18.0039H12V18Z M6 2H18V22H6V2Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]}]},{"tag":"g","attrs":{"id":"mobile-vibrate"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M6 2H18V22H6V2Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M12 18H12.0039V18.0039H12V18Z M6 2H18V22H6V2Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 18L3 6M21 18V6","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MobileVibrateIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mobile-vibrate',
    ref,
    icon: element,
  },
));

MobileVibrateIcon.displayName = 'MobileVibrateIcon';

export default MobileVibrateIcon;
